import { parse } from 'query-string';
import { getBookingEditMode } from 'Utils/ts-utils';

// A/B Test 3

// If on booking variant page
// and if shopId or selected param in the url:
// initial step is 1, else 0

// If not on booking variant page
// initial step is 1

let initialStep = 1;

if (window.location.pathname === '/booking-reskin') {
  const shopId = parse(window.location.search).shopId;
  const selected = parse(window.location.search).selected;

  if (typeof shopId === 'string' || typeof selected === 'string') {
    initialStep = 1;
  } else {
    initialStep = 0;
  }
}

if (getBookingEditMode() === 'pay' || getBookingEditMode() === 'addons') {
  // This is a temp solution, when the booking redesign is ready, this needs to be adjusted
  initialStep = 4;
}

// Enum of possible action types
export enum CurrentStepReducerActionTypes {
  CURRENT_STEP_UPDATE = 'CURRENT_STEP_UPDATE',
}

export interface CurrentStepReducerAction {
  type: CurrentStepReducerActionTypes;
  payload: number;
}

export type CurrentStepReducerState = number;

export const currentStepReducerInitialState: CurrentStepReducerState = initialStep;

const currentStepReducer = (
  state: CurrentStepReducerState,
  action: CurrentStepReducerAction
): CurrentStepReducerState => {
  switch (action.type) {
    case CurrentStepReducerActionTypes.CURRENT_STEP_UPDATE: {
      return action.payload;
    }
    default: {
      return state;
    }
  }
};

export default currentStepReducer;
